import React, { useCallback, useEffect } from 'react';
import { NotificationItem } from './NotificationItem';
import { INotification, OtherApi } from 'src/api/base/other';
import { useDispatch } from 'react-redux';
import { setNotifications } from 'src/store/notifications/slice';
import { NotificationsCard } from '../components/NotificationCard';

type PNotificationsSection = {
  notifications: Array<INotification>;
  loading: boolean;
};

export const NotificationsSection: React.FC<PNotificationsSection> = (
  props,
) => {
  const { notifications, loading } = props;
  const dispatch = useDispatch();

  const markNotificationsAsRead = useCallback(async () => {
    const unreadNotifications = notifications.filter(
      (notification) => !notification.read_at,
    );

    const readNotificationCallbacks = unreadNotifications.map(
      (notification) => {
        return OtherApi.markNotificationAsRead(notification.id);
      },
    );
    try {
      await Promise.all(readNotificationCallbacks);
      const updatedNotifications = notifications.map((notification) => {
        return { ...notification, read_at: new Date().toString() };
      });

      dispatch(setNotifications(updatedNotifications));
    } catch (error) {
      console.log(error);
    }
  }, [notifications]);

  useEffect(() => {
    if (notifications?.some((notification) => !notification.read_at)) {
      markNotificationsAsRead();
    }
  }, [notifications]);

  return (
    <NotificationsCard
      list={notifications}
      loading={loading}
      renderedItem={(item) => (
        <NotificationItem notification={item} key={item.id} />
      )}
    />
  );
};
